import { useI18n } from "@/lib/i18n";

const LegalPage = ({ tKey, sections }) => {
  const { t } = useI18n();
  return (
    <div className="bg-white" data-testid={`${tKey}-page`}>
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-20">
        <div className="eyebrow mb-4">{t(`${tKey}.updated`)}</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 mb-8">
          {t(`${tKey}.title`)}
        </h1>
        <div className="space-y-8">
          {sections.map((s) => (
            <section key={s}>
              <h2 className="font-display text-xl font-semibold text-slate-900 mb-3">
                {t(`${tKey}.${s}_title`)}
              </h2>
              <p className="text-slate-600 leading-relaxed whitespace-pre-line">
                {t(`${tKey}.${s}_text`)}
              </p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export const PrivacyPage = () => (
  <LegalPage
    tKey="privacy"
    sections={[
      "intro",
      "controller",
      "data",
      "purpose",
      "legal",
      "share",
      "retention",
      "rights",
      "security",
      "changes",
    ]}
  />
);

export const CookiesPage = () => {
  const { t } = useI18n();
  return (
    <div className="bg-white" data-testid="cookies-page">
      <div className="max-w-4xl mx-auto px-6 lg:px-10 py-20">
        <div className="eyebrow mb-4">{t("cookies_page.updated")}</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-slate-900 mb-8">
          {t("cookies_page.title")}
        </h1>
        <div className="space-y-8">
          {["intro"].map((s) => (
            <section key={s}>
              <h2 className="font-display text-xl font-semibold text-slate-900 mb-3">
                {t(`cookies_page.${s}_title`)}
              </h2>
              <p className="text-slate-600 leading-relaxed">
                {t(`cookies_page.${s}_text`)}
              </p>
            </section>
          ))}
          <section>
            <h2 className="font-display text-xl font-semibold text-slate-900 mb-4">
              {t("cookies_page.types_title")}
            </h2>
            <div className="space-y-6">
              {["necessary", "analytics", "marketing"].map((s) => (
                <div key={s} className="rounded-md border border-slate-200 p-5 bg-slate-50">
                  <h3 className="font-display font-semibold text-slate-900 mb-2">
                    {t(`cookies_page.${s}_title`)}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {t(`cookies_page.${s}_text`)}
                  </p>
                </div>
              ))}
            </div>
          </section>
          {["consent", "third", "contact"].map((s) => (
            <section key={s}>
              <h2 className="font-display text-xl font-semibold text-slate-900 mb-3">
                {t(`cookies_page.${s}_title`)}
              </h2>
              <p className="text-slate-600 leading-relaxed">
                {t(`cookies_page.${s}_text`)}
              </p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};

export const TermsPage = () => (
  <LegalPage
    tKey="terms"
    sections={[
      "intro",
      "service",
      "no_advice",
      "user",
      "ip",
      "liability",
      "changes",
      "law",
    ]}
  />
);
